(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ae-notre-histoire"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ae-story')) {
    class AeStory extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (this.isInit || !this.isConnected) return;
        this.isInit = true;
        this.classList.add('is-js');
        this.initReveal();
        this.values = this.querySelector('.ae-story__values');
        if (this.values) this.initValues();
      }

      disconnectedCallback() {
        if (this.revealObserver) this.revealObserver.disconnect();
        this.stopObservers();
        if (this.mqDesktop) this.mqDesktop.removeEventListener('change', this.onMediaChange);
        if (this.mqMobile) this.mqMobile.removeEventListener('change', this.onMediaChange);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.isInit = false;
      }

      initReveal() {
        const items = this.querySelectorAll('.ae-reveal');
        const designMode = window.Shopify && window.Shopify.designMode;
        if (!this.classList.contains('ae-story--animate') || !('IntersectionObserver' in window) || designMode) {
          items.forEach((el) => el.classList.add('is-visible'));
          return;
        }
        this.revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              this.revealObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
        );
        items.forEach((el) => this.revealObserver.observe(el));
      }

      initValues() {
        this.list = this.values.querySelector('.ae-story__list');
        this.steps = Array.from(this.values.querySelectorAll('.ae-story__step'));
        this.frames = Array.from(this.values.querySelectorAll('.ae-story__frame-item'));
        this.dots = Array.from(this.values.querySelectorAll('.ae-story__dot'));
        if (!this.steps.length) return;
        this.active = 0;
        this.values.classList.add('is-ready');

        this.mqDesktop = window.matchMedia('(min-width: 990px)');
        this.mqMobile = window.matchMedia('(max-width: 749px)');
        this.onMediaChange = () => this.startObservers();
        this.mqDesktop.addEventListener('change', this.onMediaChange);
        this.mqMobile.addEventListener('change', this.onMediaChange);
        this.startObservers();

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index)));
        });

        this.onBlockSelect = (event) => {
          const index = this.steps.findIndex((step) => step === event.target || step.contains(event.target));
          if (index > -1) this.setActive(index);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      stopObservers() {
        if (this.stepObserver) this.stepObserver.disconnect();
        if (this.cardObserver) this.cardObserver.disconnect();
        this.stepObserver = null;
        this.cardObserver = null;
      }

      startObservers() {
        this.stopObservers();
        if (!('IntersectionObserver' in window)) return;
        const scrollMode = this.values.classList.contains('ae-story__values--scroll');
        const carousel = this.values.classList.contains('ae-story__values--m-carousel');

        if (scrollMode && this.mqDesktop.matches) {
          this.stepObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.setActive(Number(entry.target.dataset.index));
              });
            },
            { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
          );
          this.steps.forEach((step) => this.stepObserver.observe(step));
        } else if (carousel && this.mqMobile.matches) {
          this.cardObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.6) this.setActive(Number(entry.target.dataset.index));
              });
            },
            { root: this.list, threshold: [0.6] }
          );
          this.steps.forEach((step) => this.cardObserver.observe(step));
        }
      }

      goTo(index) {
        const step = this.steps[index];
        if (!step) return;
        if (this.mqMobile.matches) {
          this.list.scrollTo({ left: step.offsetLeft - this.list.offsetLeft - parseFloat(getComputedStyle(this.list).paddingLeft || 0), behavior: 'smooth' });
        } else {
          step.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        this.setActive(index);
      }

      setActive(index) {
        if (index === this.active && this.steps[index].classList.contains('is-active')) return;
        this.active = index;
        this.steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
        this.frames.forEach((frame, i) => frame.classList.toggle('is-active', i === index));
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }
    customElements.define('ae-story', AeStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ae-pourquoi-nous"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ae-why')) {
    class AeWhy extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (this.isInit || !this.isConnected) return;
        this.isInit = true;
        const designMode = window.Shopify && window.Shopify.designMode;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.classList.contains('ae-why--animate') || designMode || reduce || !('IntersectionObserver' in window)) return;
        const items = this.querySelectorAll('.ae-reveal');
        this.classList.add('is-js');
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        );
        items.forEach((el) => this.observer.observe(el));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.isInit = false;
      }
    }
    customElements.define('ae-why', AeWhy);
  }

  } catch(e) { console.error(e); }
})();
})();
